
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import React from 'react';

import PreviewFormField from '../../form_fields/components/preview-renderfield';
import { shouldRenderOnPaymentModal } from '../../../shared/form-lib';
import { formDesignProps } from '../../form_fields/ctrl_proptype';
import { togglePaymentModal } from '../../form/reducer/form';
import { PaymentModalWrapper } from './form-preview.styled';
import ErrorBoundary from '../../errors/components';

const PaymentModal = ({
  onPaymentCompleted,
  isPaymentCompleted,
  hiddenFields,
  formDesign,
  ctrls
}) => {
  const { openPaymentModal } = useSelector((state) => state.form);
  const dispatch = useDispatch();
  const formDesignVariables = {
    '--formFontType': formDesign.old.form_font || 'Quicksand',
    '--formFontSize': formDesign.old.form_font_size
  };
  
  const closeModal = () => dispatch(togglePaymentModal(false));
  const completePaymentProcess = () => {
    closeModal();
    onPaymentCompleted(true);
  };

  return (
    <Modal size="small" open={openPaymentModal}>
      <PaymentModalWrapper style={formDesignVariables}>
        <button type="button" className="close-icon" onClick={closeModal}>
          <img src="https://storage.googleapis.com/fplsblog/close-icon-white.svg" alt="close_icon" />
        </button>

        <div className="header">
          <h1>Inventory payment</h1>
          {/* <h2>* Marks required payments. If payments do not go through your form data will not be lost.</h2> */}
        </div>

        <div className="content">
          {ctrls.map((ctrl) =>
            shouldRenderOnPaymentModal(ctrl, hiddenFields) ? (
              <ErrorBoundary
                title={`Customise Form Field (${ctrl.internal_id}): ${ctrl.type.split('_').join(' ')}`}
                key={`ctrl-${ctrl.internal_id}`}>
                <PreviewFormField ctrl={ctrl} rowCtrls={{}} formDesign={formDesign} isRenderedOnModal />
              </ErrorBoundary>
            ) : null
          )}
        </div>

        <div className="footer">
          <button disabled={!isPaymentCompleted} onClick={completePaymentProcess} className="complete-button" type="button">
            Complete
            {/* {!isPaymentCompleted && <span className="tooltip">You need to complete all required payment.</span>} */}
            {!isPaymentCompleted && <span className="tooltip">You need to complete inventory payment.</span>}
          </button>
        </div>
      </PaymentModalWrapper>
    </Modal>
  );
};

PaymentModal.propTypes = {
  hiddenFields: PropTypes.objectOf(PropTypes.any).isRequired,
  formDesign: PropTypes.shape(formDesignProps).isRequired,
  ctrls: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPaymentCompleted: PropTypes.func.isRequired,
  isPaymentCompleted: PropTypes.bool.isRequired
};

export default PaymentModal;
